interface VerifiedBadgeProps {
  label?: string;
  className?: string;
}

function VerifiedBadge({ label, className = '' }: VerifiedBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-accent-400 ${className}`}
      title="Artiste certifié — plus d'un million de vues"
    >
      <i className="ri-verified-badge-fill" />
      {label ? <span className="text-xs font-semibold">{label}</span> : null}
    </span>
  );
}

export default VerifiedBadge;